module.exports = __webpack_public_path__ + "static/media/sudoGPRtwo.8ed4609e.jpg";